import Vue from "vue";
import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import LoginUserHelper from "@/util/LoginUserHelper";

import { getCookie } from "@/util/cookie";
import { checkNavLimit } from "@/api/basicApi";

NProgress.configure({
  showSpinner: false
});

// router.beforeEach(async (to, from, next) => {
//   NProgress.start();
//   const token = getCookie();
//   console.log(to);
//   if (to.meta.permission) {
//     if (!token) {
//       next({ path: "/login" });
//     } else {
//       next();
//     }
//   } else {
// if (!token && to.name != "/login") {
//   next({ path: "/login" });
// } else {
//   next();
// }
//   }
// });
router.beforeEach(async (to, from, next) => {
  let CrmMenuKeys = {};
  try {
    CrmMenuKeys = JSON.parse(localStorage.getItem('CRM_MENU_KEYS') || '[]');
  } catch (error) {
    console.error('JSON解析CRM_MENU_KEYS失败');
  }
  if (to.path != "/") {
    // console.log(to.meta.title);
    document.title = to.meta.title
      ? `智能硬件代理商系统-${to.meta.title}`
      : "智能硬件代理商系统";
  }
  //
  const {ssoToken} = LoginUserHelper.getUrlParams()
  const token = LoginUserHelper.getUserToken()
  if (LoginUserHelper.checkPageWhiteList(to.path) && !ssoToken) {//路由白名单
    next();
  } else if (ssoToken) {//url存在登录token
    if(to.path != '/ssologin'){
      let ssologin = to.fullPath.replace('/#/','/')
      ssologin = ssologin.replace(to.path,'/ssologin')
      next(ssologin);
    }else{
      next()
    }
  } else if (!ssoToken && !token) {//本地无token
    LoginUserHelper.goBackLogin()
  } else {
    // 对菜单进行权限控制
    if (to.path != "/" && to.path != "/main/NoPermission") {
      const  { selectedKeys } = CrmMenuKeys[to.path] || {};
      if (selectedKeys) {
        const { isLimit, reason } = await checkNavLimit({ navId: selectedKeys });
        if (isLimit) {
          next({
            name: 'NoPermission',
            params: { reason },
            replace: false,
          });
        } else {
          next();
        }
      } else {
        next();
      }
    } else {
      next();
    }
  }
});
router.afterEach((to, from) => {
  NProgress.done();
  window.scrollTo(0, 0);
});
